export default "/images/home.svg?be4c9d9b7bc9843455913184b780dd39";